import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Bundle from '../components/Bundle';
import { incrementBundle, decrementBundle, setBundle, setBundleProductConfig } from 'checkout/views/bundle-picker/actions/bundle-picker';
import { getFeeDisplayOption } from '../../../selectors/ui';
import { getMainEvent } from '../../../selectors/event';

class BundleContainer extends Component {
    constructor() {
        super();
        this.state = {index: 0};
    }

    render() {
        return(
            <Bundle
                bundle={this.props.bundle}
                onIncrement={this.onIncrement}
                onDecrement={this.onDecrement}
                onQuantityChange={this.onQuantityChange}
                quantities={this.props.quantityArray}
                bundleQuantity={this.props.quantity}
                initialQuantities={this.props.initialQuantities}
                isPackage={this.props.isPackage}
                feeDisplayOption={this.props.feeDisplayOption}
            />
        );
    }

    onQuantityChange = (e) => {
        this.props.setBundle(this.props.bundle.id, +e.target.value);
    };

    onIncrement = () => {
        this.props.incrementBundle(this.props.bundle.id);
        Object.values(this.props.bundle.contents.products).map(product => {
            if (product.single_configuration) {
                this.props.setBundleProductConfig({
                    bundleId: this.props.bundle.id,
                    index: this.state.index++,
                    productId: product.product_id,
                    configurationId: product.configurations[0].product_configuration_id,
                });
            }
        })
    };

    onDecrement = (id) => {
        this.props.decrementBundle(id);
    }
}

const mapStateToProps = (state, props) => {
    return {
        bundle: state.bundles.bundles[props.bundleId],
        quantityArray: Object.keys(state.bundlePicker.availableQuantities).length > 0 ? state.bundlePicker.availableQuantities[props.bundleId] : state.bundlePicker.bundleQuantityArrays[props.bundleId],
        quantity: state.bundlePicker.bundleQuantities[props.bundleId],
        initialQuantities: state.bundlePicker.bundleQuantityArrays[props.bundleId],
        isPackage: !!getMainEvent(state)?.event?.isPackage,
        feeDisplayOption: getFeeDisplayOption(state),
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({incrementBundle, decrementBundle, setBundle, setBundleProductConfig}, dispatch);
};

BundleContainer.propTypes = {
    bundles: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleContainer)
